/*  ========================================================================
    # Scripts - Menu Toggle
    ========================================================================  */

/**
 * Script that triggers the mobile menu
 */

const MenuToggle = {
  cfg: {
    buttonElement: document.getElementById('menu-toggle'),
    menuWrapperElement: document.getElementById('menu-mobile-wrapper'),
    submenuToggle: document.querySelectorAll('.c-header__submenu-toggle'),
    submenuWrapperClass: '.c-header__submenu-wrapper',
    menuLinkWrapperClass: '.c-header__menu-link-wrapper',
    states: {
      activeButton: 'c-header__menu-toggle--active',
      activeMenuWrapper: 'c-header__menu-mobile-wrapper--active',
      activeSubmenu: 'c-header__submenu-wrapper--active',
      activeSubmenuToggle: 'c-header__submenu-toggle--active',
      activeBodyClass: 'menu-open'
    }
  },

  /**
   * Handle menu toggle click
   */
  handleMenuToggle() {
    this.cfg.buttonElement.addEventListener('click', () => {
      this.cfg.buttonElement.classList.toggle(this.cfg.states.activeButton);
      this.cfg.menuWrapperElement.classList.toggle(this.cfg.states.activeMenuWrapper);
      document.body.classList.toggle(this.cfg.states.activeBodyClass);
    });
  },

  /**
   * Handle submenu toggle click
   */
  handleSubitemToggle() {
    if (this.cfg.submenuToggle.length > 0) {
      this.cfg.submenuToggle.forEach(submenu => {
        submenu.addEventListener('click', e => {
          const submenuWrapper = document.getElementById(e.target.dataset.for);
          e.target.classList.toggle(this.cfg.states.activeSubmenuToggle);
          submenuWrapper.classList.toggle(this.cfg.states.activeSubmenu);
        });
      });
    }
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.buttonElement) {
      this.handleMenuToggle();
      this.handleSubitemToggle();
    }
  }
};

export default MenuToggle;
